import conversations from './sidebarItems/conversations';
import contacts from './sidebarItems/contacts';
import lists from './sidebarItems/lists';
import reports from './sidebarItems/reports';
import analytics from './sidebarItems/analytics';
import campaigns from './sidebarItems/campaigns';
import settings from './sidebarItems/settings';
import notifications from './sidebarItems/notifications';
import primaryMenu from './sidebarItems/primaryMenu';
//import wasettings from './sidebarItems/wasettings';

export const getSidebarItems = accountId => ({
  primaryMenu: primaryMenu(accountId),
  secondaryMenu: [
    conversations(accountId),
    lists(),
    contacts(accountId),
    reports(accountId),
    analytics(accountId),
    campaigns(accountId),
    settings(accountId),
    //wasettings(accountId),
    notifications(accountId),
  ],
});
